import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SaveComment } from '../../model/saveComment';
import { CommentService } from '../../shared/comment.service';
import { CommonService } from '../../shared/common.service';
import { ReturnObject } from '../../model/returnobject';
import { UserService } from '../../shared/user.service';
import { User } from '../../model/user';
import { CafsComment } from '../../model/comment';
import { StatusMessagesService } from '../../shared/statusmessage.service';

@Component({
  selector: 'comment-dialog',
  templateUrl: 'comment-dialog.html',
  styleUrls: ['./comment-dialog.scss']
})
export class CommentDialog implements OnInit {
  @Input() assignmentNumber: string = '';
  @Input() department: string = '';
  @Input() assignmentManager: string = '';
  @Input() showMe: boolean = false;
  @Input() addedCommentsCount:number = 0;

  @Output() onCloseDlg: EventEmitter<number> = new EventEmitter<number>();

  loggedUser: User = User.getEmpty();
  comments: CafsComment[] = [];
  commentInput: string = '';
  showFailMsg: boolean = false;
  showSuccMsg: boolean = false;
  user: User = new User();
  showLoading: boolean = false;
  
  constructor(
    private common: CommonService,
    private commentApi: CommentService,
    private userService: UserService,
    private statusMessagesService: StatusMessagesService
  ) { }

  ngOnInit() {
    this.showMe = true;
    this.initServices();
  }

  initServices() {
    this.showLoading = true;
    this.loggedUser = this.userService.getUser();
    this.getComments(this.assignmentNumber);
  }

  getComments(assignmentNumber: string) {
    this.showLoading = true;
    this.commentApi.getComments(assignmentNumber)
      .subscribe({
            next: (res: ReturnObject<CafsComment[]>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', 'Failed to load Comments');
                return;
              }
      
              this.comments = res.value;
      
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }


  addComment(comment: string) {
    if (comment.length < 1 || comment.length > 2000)
      return;

    this.showLoading = true;

    this.commentApi.addComment(new SaveComment(comment, this.assignmentNumber))
      .subscribe({
            next: (res: ReturnObject<string>) => {
              if (res.isFailure) {
                this.showAddStatus(true);
                this.statusMessagesService.showToasterError('Error', 'Failed to add Comments');
                return;
              }
      
              this.getComments(this.assignmentNumber);
              this.showAddStatus();
              this.commentInput = '';
              this.addedCommentsCount  += 1;
              this.statusMessagesService.showToasterInfo('Saved', res.value);
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }


  deleteComment(commentId: number) {
    this.showLoading = true;

    this.commentApi.deleteComment(commentId)
      .subscribe({
            next: (res: ReturnObject<string>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', res.failureMessage);
                return;
              }
      
              this.getComments(this.assignmentNumber);
              this.addedCommentsCount -= 1;
              this.statusMessagesService.showToasterInfo('Deleted', res.value);
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }

  closeDialog() {
    this.showMe = false;
    this.onCloseDlg.emit(this.addedCommentsCount);
  }

  showAddStatus(addFailed: boolean = false) {
    if (addFailed)
      this.showFailMsg = true;
    else
      this.showSuccMsg = true;

    setTimeout(() => {
      this.showFailMsg = false;
      this.showSuccMsg = false;
    }, 4000);
  }

  isAllowedToEditComments(): boolean {
    return this.loggedUser.accessFeatures.includes('commentall')
      || (this.loggedUser.accessFeatures.includes('commentown')
        && this.loggedUser.id == this.assignmentManager);
  }

  isValuesSet(): boolean {
    return !this.common.isNullOrWhiteSpace(this.commentInput);
  }
}
